import { Camera, Check, EyeOff, Move, TimerReset } from "lucide-react";
import { useLocale } from "./i18n.tsx";
import { Page, type Session } from "./Shell.tsx";

export function HomePage({ session }: { session: Session | null }) {
  const { copy, href } = useLocale();
  const text = copy.home;
  return (
    <Page session={session} className="home-page">
      <main id="main">
        <section className="hero page-shell">
          <div className="hero-copy">
            <p className="eyebrow">{text.eyebrow}</p>
            <h1>{text.titleA}<br /><em>{text.titleB}</em></h1>
            <p className="hero-lead">{text.lead}</p>
            <div className="hero-actions">
              <a className="button button-primary button-large" href={href("/play/firefly")}><Camera aria-hidden="true" />{copy.common.play}</a>
              <a className="text-link" href="#how">{text.howLink}</a>
            </div>
            <ul className="trust-list" aria-label={text.eyebrow}>
              <li><Check aria-hidden="true" />{text.noInstall}</li>
              <li><Check aria-hidden="true" />{text.free}</li>
              <li><Check aria-hidden="true" />{text.local}</li>
            </ul>
          </div>
          <div className="hero-game" aria-label={text.demoLabel}>
            <div className="hero-orbit orbit-one"><span /></div>
            <div className="hero-orbit orbit-two"><span /></div>
            <div className="hero-face"><span className="face-eye left" /><span className="face-eye right" /><span className="face-smile" /></div>
            <div className="hero-target" />
            <p><span>01</span><strong>{text.demoCue}</strong></p>
          </div>
        </section>

        <section className="privacy-strip">
          <EyeOff aria-hidden="true" />
          <p><strong>{text.privacyTitle}</strong> {text.privacyBody}</p>
        </section>

        <section id="how" className="how-section page-shell">
          <header><p className="eyebrow">{text.simple}</p><h2>{text.howTitle}</h2></header>
          <div className="step-grid">
            <article><span>1</span><Camera aria-hidden="true" /><h3>{text.step1}</h3><p>{text.step1Body}</p></article>
            <article><span>2</span><Move aria-hidden="true" /><h3>{text.step2}</h3><p>{text.step2Body}</p></article>
            <article><span>3</span><TimerReset aria-hidden="true" /><h3>{text.step3}</h3><p>{text.step3Body}</p></article>
          </div>
        </section>

        <section className="safety-section page-shell">
          <div><p className="eyebrow">{text.comfort}</p><h2>{text.safetyTitle}</h2></div>
          <p>{text.safetyBody}</p>
        </section>

        <section className="faq-section page-shell" aria-labelledby="faq-title">
          <header><p className="eyebrow">FAQ</p><h2 id="faq-title">{text.faqTitle}</h2></header>
          <div className="faq-grid">
            <article><h3>{text.faqCamera}</h3><p>{text.privacyBody}</p></article>
            <article><h3>{text.faqFree}</h3><p>{copy.content.accountLoginLead}</p></article>
            <article><h3>{text.faqSafe}</h3><p>{text.safetyBody}</p></article>
            <article><h3>{text.faqHow}</h3><p>{text.step2Body} {text.step3Body}</p></article>
          </div>
        </section>

        <section className="closing-cta page-shell">
          <div><p className="eyebrow">{text.now}</p><h2>{text.minute}</h2><p>{text.closing}</p></div>
          <a className="button button-primary button-large" href={href("/play/firefly")}>{copy.common.play}</a>
        </section>
      </main>
    </Page>
  );
}
